<div class="view-container">
  <div class="queues">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
          fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Queues</label>
          <button mat-flat-button type="button" color="accent" (click)="onClickAddQueue()" matTooltip="Add Queue">
            <mat-icon>add</mat-icon>Add Queue
          </button>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search queues by name</mat-label>
                <input matInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="loadQueues()"
                  (keyup.esc)="searchTerm=''; loadQueues()" name="searchTerm" placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
                  (click)="searchTerm=''; loadQueues()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <button type="submit" mat-flat-button color="primary" (click)="loadQueues()" matTooltip="Search"
                  [class.button-spinner]="loading" [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="contrast" *ngFor="let item of queuesDataSource.data" [class.banner-error]="item?.disabled"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="30" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px">
              <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | highlight: searchTerm"
                [matTooltip]="item?.id"></strong>
            </div>
            <div fxFlex="70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="18px">
              <div fxFlex="90" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column"
                fxLayoutAlign.lt-sm="center center" class="date-text">
                <p><small>Messages</small></p>
                <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ getQueueCount(item) }}</div>
                <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                <p><small>Renderers</small></p>
                <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item.rendererQueues.length }}</div>
              </div>

              <!-- <div fxFlex="10" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                <button mat-mini-fab color="accent" aria-label="View Queue" matTooltip="View Queue"
                  (click)="onViewQueue(item.id)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div> -->
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>